'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosSearch = function IoIosSearch(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 33.2l-1.8 1.8-8.8-8.8c-2.1 1.6-4.7 2.6-7.5 2.6-6.6 0-11.9-5.4-11.9-11.9s5.3-11.9 11.9-11.9 11.9 5.3 11.9 11.9c0 2.8-1 5.4-2.6 7.4z m-25.6-8.7c2 2 4.7 3 7.5 3s5.4-1.1 7.5-3.1 3.1-4.7 3.1-7.5-1.1-5.5-3.1-7.5-4.7-3.1-7.5-3.1-5.5 1-7.5 3.1-3.1 4.7-3.1 7.5 1 5.5 3.1 7.6z' })
        )
    );
};

exports.default = IoIosSearch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-search.js
// module id = 2306
// module chunks = 0